<template>
	<div v-if="user.subscription">
		<section class="pb-2">
			<div class="form" >
				<div class="flex tag-partner" v-if="user.subscription.partners.edenred">
					<h3>Ticket Restaurant®</h3>
					<div class="flex-right" >
						<div @click="logout" class="link-detail" v-if="!loading['edenred']">Disconnetti il tuo account</div>
						<div v-else>
							Caricamento...
						</div>
					</div>

				</div>

				<br>

				<div v-if="!loading['wallet']" class="flex align-items-center">
					<h3 style="margin: 0">Portafoglio</h3>
					<div class="price flex-right" v-if="wallet">
						{{ wallet.wallet }} {{ $t("general.currency")}}
					</div>
				</div>

				<br>

				<div class="tag-partner">
					<h3>Premio Invita un amico</h3>
					<div v-for="(coupon, index) in refer.src" v-if="refer.src" :key="index">
						- Coupon #{{ coupon.id }}: {{ coupon.amount.toFixed(2) }} {{ $t("general.currency")}}
					</div>
				</div>
			</div>
		</section>
		<hr>
		<h3
			v-html="`Metodo di pagamento`"
			class="pt-3"
		/>

		<section>
			<div class="form">
				<p v-if="user.subscription && user.subscription.payment_method">
					Attualmente stai utilizzando
					<span
						v-text="$t('components.payment.method_' + user.subscription.payment_method.replace(/\s+/g, '_'))"
					/>	
				</p>
				<div class="payment-form">
					<label class='form-field-row checkout-card tag-partner' for='method_paypal'>
						<div class="checkout-payment-select">
							<input
								type="radio"
								id='method_paypal'
								class='hide'
								:checked="method === 'paypal'"
								@click="selectMethod('paypal')"
							>
							<div
								class="check"
								for='method_paypal'
							/>
							<span>
								{{ $t("components.payment.paypal") }}
								<br>
								<span
									class='payment-free'
									v-html="$t('components.payment.free')"
								/>
							</span>

							<span
								class='checkout-payment-icons pr-5'
							>
								<img
									src="https://api.quomi.it/oldimg/paypal-quomi.webp"
									alt='logo paypal'
								>
							</span>
						</div>
					</label>

					<label class='form-field-row checkout-card' for='method_credit-card'>
						<div class="checkout-payment-select">

						<input
							type="radio"
							id='method_credit-card'
							class='hide'
							:checked="method === 'creditCard'"
							@click="selectMethod('creditCard')"
						>
						<div
							class="check"
							for='method_credit-card'
						/>
						<span>{{ $t("components.payment.credit_cart") }}<br>
							<span
								class='payment-free'
								v-html="$t('components.payment.free')"
							/>
						</span>

						<span
							class='checkout-payment-icons'
						>
							<img src="https://api.quomi.it/oldimg/metodi-pagamento-quomi.webp" :alt='$t("components.payment.accepted_cards")'>
						</span>

						</div>

					</label>

					<div v-show="method === 'creditCard'" class="card-form">
						<div id="setup-form">
						  <div id="payment-element"></div>
						</div>

						<div
							v-if="stripe.error"
							class='error'
							v-html="stripe.error.message"
						/>
					</div>
				</div>

				<flash
					:flash="flash"
					:state="state"
				/>

				<CTA
					isWithLoader
					:content="`Aggiorna`"
					isArrow
					@click="updatePayment()"
					:loading="updating"
				/>
			</div>
		</section>
	</div>
</template>

<script>
import { UserApi } from '../../api/UserApi'
import { OrderApi } from '../../api/OrderApi'
import { Card, createToken } from 'vue-stripe-elements-plus'
import Flash from '../Parts/Flash'
import { prices } from '../../mixins/prices'
import { EdenredApi } from '../../api/EdenredApi'
import { stepPaymentStore } from '../../store/stepPaymentStore'

import { errorStore } from '../../store/errorStore'
import { stripeHelper } from '../../mixins/stripeHelper'  

// USED ON PROFILE
export default {
	mixins: [
		prices,
        stripeHelper
	],

	computed: {
		user () {
			return this.$root.user
		},
		order () {
			return this.user.order
		},

        edenredState () {
        	return {
        		confirmed: this.orderHasEdenred,
        		estimated: this.edenredTicketEstimated,
        		authorized: this.edenredTicketEstimated || this.orderHasEdenred
        	}
        }
	},

	data () {
		return {
            redirectTo: 'profile',
			errorStore: errorStore.state,

			method: null,

			wallet: null,
			refer: {
				src: null,
				total: 0
			},

			loading: {
				wallet: false,
				refer: false,
				edenred: false
			},

			flash: null,
			state: null,

			updating: false,
		}
	},

	components: {
		Card,
		Flash
	},

	methods: {

		logout () {
			this.loading['edenred'] = true
			var token = this.user.order.token
			var em = new EdenredApi()			
			return em.logout(token)

			.then(response => {
				var user = this.user
				user.subscription.partners.edenred = false
                if (user) user.order = response.body.data.resource
    
				this.$root.updateUser(user)

				this.loading['edenred'] = false
			})
		},

		selectMethod (method) {
			this.method = method
		},

		onUpdateStripeCard ($event) {
			this.stripe.error = $event.error
			this.stripe.complete = $event.complete
		},

		loadWallet () {
			this.loading['wallet'] = true
			var um = new UserApi()
			um.wallet().then(response => {
				this.wallet = response.body.data
				this.loading['wallet'] = false
			})
		},
		loadRefer () {
			this.loading['discount'] = true
			var um = new UserApi()
			um.discount().then(response => {
				var source = response.body.resources
				var refer = typeof source === 'object' ? Object.values(source) : source
				this.refer.src = refer.filter(r => r.type === 'REWARD_REFER' && r.unit === 'i')
				refer.forEach(r => { this.refer.total += r.amount })
				this.loading['discount'] = false
			})
		},

		updatePayment () {
			this.flash = null
			this.updating = true

			if (!this.user.subscription) return

			var om = new OrderApi()

			if (this.method === 'creditCard') {
				return stepPaymentStore.makeAgreementStripe().then(response => {
					this.flash = "Modifiche applicate. Ricordati che è necessario riconfermare l'ordine!";
					this.state = 'success'
					this.updating = false
				}).catch(response => {
					this.flash = errorStore.format(response)
					this.state = 'error'
					this.updating = false
				})
			}
			if (this.method === 'paypal') {
				om.askPaypal({
					redirect_url_success: location.protocol+'//'+location.host + '/profile/paypal/success',
					redirect_url_cancel: location.protocol+'//'+location.host + '/profile/paypal/cancel',
					subscription_token: this.user.subscription.token
				}).then(response => {
					window.location.href = response.body.data.redirect
				}).catch(response => {

				})

				// Redirect page flow
			}
		}
	},

	mounted () {
		if (!this.user) return
		if (!this.user.subscription) return

		this.flash = this.$route.params.error ? this.$route.params.error : null
		this.state = this.$route.params.state ? this.$route.params.state : null

		this.method = this.user.subscription.payment_method === 'paypal' ? 'paypal' : 'creditCard'

		this.loadWallet()
		this.loadRefer()

    this.initializeStripe();
	}
}

</script>

<style scoped>
.price {
	font-size: 20px;
}

.form {
	max-width: 700px;
}

.checkout-card{
	border-radius: 4px;
	cursor: pointer;
	-webkit-transition: border-color .3s;
	transition: border-color .3s;
	display: flex;
	margin: 20px auto;
}

.card-form {
	margin: 20px auto;
}
.checkout-card:hover {
	background-color: #EDEDED;
}
.checkout-payment-icons{
	display:flex;
	align-items: center;
	margin-left: auto;
}
.checkout-payment-icons img{
	max-height: 30px;
	width: auto;
	mix-blend-mode: multiply;
}
.checkout-payment-select{
	width:100%;
	display: flex;
	padding: 5px;
	align-items: center;
	flex-wrap: nowrap;
  font-size: 13px;
}

.checkout-payment-select input[type='radio']{
	height: 16px;
	width: 16px;
	margin-right: 5px;
}

.cc-label {
	padding: 0 0 10px 0;
}

.cc-label > div {
	padding: 0 10px;
}
.payment-free{
	color:var(--quomi-primary);
	font-style: normal;
	font-size: 12px;
}

.checkout-payment-select .radio {
	position: relative;
	display: inline-block;
	height: 50px;
	width: 50px;
	z-index: 2;
}
.checkout-payment-select .check {
	position: relative;
	display: inline-block;
	min-height: 30px;
	min-width: 30px;
	margin-right: 10px;
}

.cc-stripe {
	border: 2px solid #ededed;
	padding: 15px;
	border-radius: 4px;
}
.col-3 .check {
	cursor: pointer;
	height: 37px;
}
.checkout-payment-select .radio::after,
.checkout-payment-select .radio::before,
.checkout-payment-select .check::after,
.checkout-payment-select .check::before {
	position: absolute;
	top: 0;
	left: 0;
	content: '';
	height: 100%;
	width: 100%;
	/* Force hardware acceleration */
	-webkit-transform: translateZ(0);
			transform: translateZ(0);
	-webkit-backface-visibility: hidden;
			backface-visibility: hidden;
}
.checkout-payment-select .radio::before {
	/* green circle */
	border: 3px solid #ffffff;
	background: #EDEDED;
	-webkit-transition: background-color .3s, border-color .3s, -webkit-transform .3s;
	transition: background-color .3s, border-color .3s, -webkit-transform .3s;
	transition: background-color .3s, transform .3s, border-color .3s;
	transition: background-color .3s, transform .3s, border-color .3s, -webkit-transform .3s;
}
.checkout-payment-select .check::before {
	/* green square */
	border: 1.5px solid var(--quomi-primary);
	background: #ffffff;
	-webkit-transition: background-color .3s, border-color .3s, -webkit-transform .3s;
	transition: background-color .3s, border-color .3s, -webkit-transform .3s;
	transition: background-color .3s, transform .3s, border-color .3s;
	transition: background-color .3s, transform .3s, border-color .3s, -webkit-transform .3s;
}
.checkout-payment-select .radio::after,
.checkout-payment-select .check::after {
	background: url('../../assets/img/content/icon-check.svg') no-repeat center center;
}
.checkout-payment-select .radio::before {
	border-radius: 50%;
}
.checkout-payment-select .check::before {
	border-radius: 4px;
}
.checkout-payment-select .selected .radio::before {
	background: var(--quomi-primary);
	border-color: #ffffff;
}
.checkout-payment-select .selected .check::before {
	background: var(--quomi-primary);
	border-color: var(--quomi-primary);
}

input[type="radio"]:checked + .check::before {
	background: var(--quomi-primary);
	border-color: var(--quomi-primary);
}

@media (max-width: 800px) {
	.section-title {
		flex-wrap: wrap;
	}

	.checkout-payment-icons img {
		max-height: 30px;
	}

	.icons {
		margin: 10px 0;
	}

}
</style>
